// The slider is throttled.
export const FILTER_FRAMES_PER_SECOND = 15;
